export class POBPermissionDetails {
  public POB_Staff_Add: boolean = false;
  public POB_Contractor_Add: boolean = false;
  public POB_SecurityManager_Approve: boolean = false;
  public POB_HSEManager_Approve: boolean = false;
  public POB_SecurityCoordinator_Approve: boolean = false;
  public POB_Admin: boolean = false;
  public POB_View: boolean = false;
  public POB_SecurityCheckInOut: boolean = false;
  public POB_Own: boolean = false;
  public POB_Staff_Add_Unit: boolean = false;
  public POB_Contractor_Add_Unit: boolean = false;
  public POB_Admin_Unit: boolean = false;
  public POB_View_Unit: boolean = false;
  public POB_ContractHolderApprove: boolean = false;
}
